import dayjs from "dayjs";
import "dayjs/locale/fr";
import type {ReactNode} from "react";

dayjs.locale("fr");

type Props = {
  actions?: ReactNode;
  children: ReactNode;
};

/**
 * Common chrome for all document cards (note / file / photos) — avatar + author + time on
 * the left, contextual actions on the right (typically edit + delete that appear on hover),
 * card body below.
 */
export function DocumentCardChrome({actions, children}: Props) {
  return (
    <div className="border rounded bg-white m-1 document-card">
      <div className="d-flex justify-content-between align-items-center mb-2">
        {children}
        {actions && <div className="document-card-actions">{actions}</div>}
      </div>
    </div>
  );
}
